import clsx from 'clsx';
import React from 'react';

import { OfferPriceProps } from '../interfaces';

const OfferPrice = ({
  className,
  offer: {
    currentPrice,
    currentPriceDisplayOverride,
    originalPrice,
    originalPriceDisplayOverride,
    billingFrequencyOverride,
  },
  upgradeSavings,
}: OfferPriceProps) => {
  const currentPriceToDisplay = currentPriceDisplayOverride || currentPrice;
  const hasDiscount = originalPrice !== currentPrice;
  const originalPriceToDisplay = originalPriceDisplayOverride || originalPrice;

  return (
    <>
      <div className={clsx('flex flex-wrap items-center justify-center', className)}>
        <span className="font-suisse-screen text-caption-lg !font-medium text-grayscale-charcoal sm:text-headline-alt-sm">
          ${currentPriceToDisplay.toFixed(0)}
        </span>
        {hasDiscount && (
          <span className="ml-8 font-suisse-screen text-disclosure-lg font-normal text-grayscale-gray line-through sm:text-headline-alt-sm">
            ${originalPriceToDisplay.toFixed(0)}
          </span>
        )}
        {billingFrequencyOverride && (
          <span className="ml-8 whitespace-nowrap font-suisse-screen !text-disclosure-md text-grayscale-charcoal">
            {billingFrequencyOverride}
          </span>
        )}
      </div>
      {upgradeSavings && (
        <span className="font-screen-suisse mx-auto mb-8 block text-byline-md font-normal text-grayscale-gray sm:mb-16">
          {upgradeSavings}
        </span>
      )}
    </>
  );
};

export default OfferPrice;
